<template>
  <v-container class="pa-0 pt-1" fluid>
    <v-row
      justify="center"
      align="center"
    >
      <v-dialog
        ref="dialog"
        v-model="modal"
        :return-value.sync="date"
        persistent
        width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            style="max-width: 200px"
            v-model="date"
            label="Selecione o Mês"
            append-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
            hide-details
            outlined
            dense
          ></v-text-field>
        </template>
        <v-date-picker locale="pt-br" v-model="date" type="month" scrollable @change="atualizarDados()">
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
          <v-btn text color="primary" @click="$refs.dialog.save(date)">OK</v-btn>
        </v-date-picker>
      </v-dialog>
      <v-btn @click="atualizarDados()" class="primary ml-3" style="width: 32px; height: 32px" dark icon>
        <v-icon>
          mdi-refresh
        </v-icon>
      </v-btn>
    </v-row>
    <v-row class="mt-4" no-gutters>
      <v-card class="mb-4" width="100%" v-for="(item, index) in items" :key="index" flat>
        <!-- <v-divider></v-divider> -->
        <table style="width: 100%; border-spacing: 0px">
          <tr>
            <td class="pl-2"><b>Dia {{ String(item.dia).padStart(2, '0') }}</b></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td class="pl-2"><b>Vendas</b></td>
            <td class="pr-2 text-right">{{ item.vendas | formatCurrency }}</td>
            <td class="pl-2"><b>Percas</b></td>
            <td class="pr-2 text-right">{{ item.percas | formatCurrency }}</td>
          </tr>
          <tr>
            <td class="pl-2"><b>Compras</b></td>
            <td class="pr-2 text-right">{{ item.compras | formatCurrency }}</td>
            <td class="pl-2"><b>Lucro-Bruto</b></td>
            <td class="pr-2 text-right">{{ item.lucro | formatCurrency }}</td>
          </tr>
          <tr>
            <td class="pl-2"><b>Impostos</b></td>
            <td class="pr-2 text-right">{{ item.impostos | formatCurrency }}</td>
            <td class="pl-2"><b>Rentabilidade</b></td>
            <td class="pr-2 text-right">{{ parseFloat(item.rentabilidade).toFixed(2) }}%</td>
          </tr>
        </table>
      </v-card>
      <v-card v-if="items.length" class="mb-3 mt-2" width="100%" flat>
        <!-- <v-divider></v-divider> -->
        <v-card-title class="ml-n2 my-n2">
          Totalizador
        </v-card-title>
        <table style="width: 100%; border-spacing: 0px; border-top: 1px solid #CCC">
          <tr>
            <td class="pl-2"><b>Vendas</b></td>
            <td class="pr-2 text-right">{{ totais.vendas | formatCurrency }}</td>
          </tr>
          <tr>
            <td class="pl-2"><b>Compras</b></td>
            <td class="pr-2 text-right">{{ totais.compras | formatCurrency }}</td>
          </tr>
          <tr>
            <td class="pl-2"><b>Impostos</b></td>
            <td class="pr-2 text-right">{{ totais.impostos | formatCurrency }}</td>
          </tr>
          <tr>
            <td class="pl-2"><b>Percas</b></td>
            <td class="pr-2 text-right">{{ totais.percas | formatCurrency }}</td>
          </tr>
          <tr>
            <td class="pl-2"><b>Lucro-Bruto</b></td>
            <td class="pr-2 text-right">{{ totais.lucro | formatCurrency }}</td>
          </tr>
          <tr>
            <td class="pl-2"><b>% Rentabilidade</b></td>
            <td class="pr-2 text-right">{{ ((totais.lucro / (totais.vendas))  * 100) | formatPercentual }}%</td>
          </tr>
        </table>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
import * as api from '@/api/lucratividade'
import { mapMutations } from 'vuex'

export default {
  filters: {
    formatCurrency (number) {
      return number.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
    },
    formatPercentual (valor) {
      valor = parseFloat(valor).toFixed(2).replace('.', ',')
      valor = valor.toString()
      var pattern = /(-?\d+)(\d{3})/
      while (pattern.test(valor)) {
        valor = valor.replace(pattern, '$1.$2')
      }
      return valor
    }
  },
  data () {
    return {
      date: new Date().toISOString().substr(0, 7),
      menu: false,
      modal: false,
      items: [],
      totais: {
        vendas: 0,
        compras: 0,
        impostos: 0,
        percas: 0,
        lucro: 0
      }
    }
  },
  mounted () {
    this.atualizarDados()
  },
  methods: {
    ...mapMutations('global', ['setLoading']),
    async atualizarDados () {
      // console.log(this.date)
      this.setLoading(true)
      try {
        this.zerarTotais()
        this.items = await api.buscarDadosTabela({ anoMes: this.date })
        for (const item of this.items) {
          this.totais.vendas += item.vendas
          this.totais.compras += item.compras
          this.totais.impostos += item.impostos
          this.totais.percas += item.percas
          this.totais.lucro += item.lucro
        }
        if (this.items.length) {
          this.$toast.success('Os dados foram atualizados.', 'Sucesso!', { timeout: 2000 })
        } else {
          this.$toast.error('Verifique o mês informado.', 'Não há dados disponíveis.')
        }
      } catch (error) {
        this.$toast.error(error, 'Ocorreu um Erro!')
      }
      this.setLoading(false)
    },
    zerarTotais () {
      this.totais.vendas = 0
      this.totais.compras = 0
      this.totais.impostos = 0
      this.totais.percas = 0
      this.totais.lucro = 0
    }
  }
}
</script>

<style scoped>
td, tr {
  height: 22px !important;
}

tr:nth-child(even) {
  background-color: #e6f1fd;
}
</style>
